<div class="close-x">
    <button cdkFocusInitial aria-label="Close dialog" (click)="closeClick()">
        <now-media-image [imageOptions]="imageOptions" size="width"></now-media-image>
    </button>
</div>
